export const THEME_MODE = "THEME_MODE";